module.exports = __webpack_public_path__ + "static/media/friends-of-tmc.bf7b79ea.png";